import React from "react";
import logo from "../assets/img/mse-logo.webp";
import { Link } from "react-router-dom";

const TestInfo = () => {
  return (
      <div className="container-fluid p-0">
        <div className="container mt-4">
          <div className="d-flex justify-content-between align-items-start responsive-img">
            <div>
              <h4>Welcome to the MSE UCAT Practice Test.</h4>
              <p>
                These tests are designed to replicate closely the official UCAT exam.
              </p>
            </div>
            <img
              src={logo}
              alt="MSE Logo"
              className="img-fluid"
              style={{ maxWidth: "250px" }}
            />
          </div>

          <div>
            <h4>MSE Practice Test Guidance</h4>
            <h5>Scoring</h5>
            <p>Regarding the final score please note that it is not a scaled score. Unlike your real UCAT exam, 
              you will be provided with information regarding which of your answers are correct/incorrect. This is for your learning and reflection.</p>
          </div>

          <div>
            <h5>Calculator</h5>
            <p>
                An onscreen calculator is available by clicking the button at the top left of the screen. The calculator opens in a separate window. It is a basic calculator unable to do scientific operations.
                <br />
                Type in the calculator click the button. You can move the calculator by dragging it to your desired position. To use a calculator, click on the buttons with your mouse or keyboard (ensure that ‘Num’ Lock is on). Use the X button to close it.
                <br />
                If you move from the calculator back to the test the calculator will not work until you click back on it.
            </p>
          </div>

          <div>
            <h5>Working Out</h5>
            <p>On your test day, you will be given a laminated notebook and pen. You may wish to have some paper with you before starting THIS test.
            </p>
          </div>

          <div>
            <h5>Keyboard Shortcuts</h5>
            <ul>
              <li> Use Alt + N to go to the next screen or question  </li>
              <li> Use Alt + P to go to the previous question </li>
              <li> Use Alt + C to bring up the calculator  </li>
              <li> Use Alt + F to flag a question  </li>
              <li> Use Alt + V to bring up the Navigator window  </li>
            </ul>
          </div>
          <p>
            When a letter is underlined, the Alt key can be used with the underlined letter key as a shortcut: Alt + P = previous.  <br />
            Shortcuts can also be used to select answers. If you wish to select option A just press the ‘A’ key.  <br />
            Some answers require you to drag and drop in these situations you must use the mouse.
          </p>
          <h5>Visualising the screen</h5>
          <p>
            If you cannot see the full text, use the scroll bar on the right and scroll down or use the scroll bar below and drag to the right. 
            A pop-up indicator will appear if you have not read the entire content and you will be unable to move on until you have done so.
          </p>
          <h5>Timer </h5>
          <p>
            Each subtest is separately timed. You can check your timing with the Timer at the top right of the screen. This will count downward; it will turn yellow when 5 minutes are remaining. When the time has run out the timer will begin then next section. 
            At the start of the next section click OK to continue” otherwise you will lose valuable time.
            The 'Navigator' function at the bottom right of the screen allows you to navigate to questions within the subtest.
          </p>
          <h5>Flagging</h5>
          <p>
            You may wish to flag a question to review. The Flag button will be at the top right of the screen. Use the 'Navigator' to check which questions you have flagged. Flagged and incomplete questions will also appear in the Review Screen. If a question is flagged, a blue flag will appear.
          </p>
          <h5>Navigator</h5>
          <p>
            The Navigator function is at the bottom right of the screen. You may wish to use it to go to a specific question such as flagged/answered questions. You can only use it to go to questions in that particular subtest. To close the Navigator window, click the X button in the top right.
            <br />
            For more advice go to the Official UCAT website.
          </p>
          <p className="lead"><i>Good luck!</i></p>
          <p className="">
            Please click the <strong>Next (N)</strong> button when you are
            ready to begin the practice test.
          </p>
          <p className="lead mb-5"><i>Dr Afrosa Ahmed & Dr Rizvia Khan <br />
            Directors MSE</i>
          </p> <br />


        </div>
      </div>
  );
};

export default TestInfo;
